
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import { MarketingCampainDto } from "@/dtos/marketingCampaignDto";
import Plattforms from "@/dtos/socialMediaPlattform";

@Component
export default class AdCampaigns extends Vue {
	private links: MarketingCampainDto[] = [];
	private loading: boolean = false;
	private showAll: boolean = true;
	private plattforms: any = Plattforms;
	private headers: any[] = [
		{
			text: "Link",
			sortable: false,
		},
		{
			text: "Titel",
			sortable: false,
		},
		{
			text: "Ziel",
			sortable: false,
		},
		{
			text: "Erstellt am",
			sortable: false,
		},
		{
			text: "Total Klicks",
			sortable: false,
		},
		{
			text: "Registrierungen",
			sortable: false,
		},
	];
	private mounted() {
		this.loadLinks();
	}

	private async loadLinks() {
		const response = await httpClient().get(`Marketing/GetMarketingLinks`);
		this.links = response.data;
	}

	private get shownLinks() {
		if (this.showAll) {
			return this.links;
		}
		return this.links.filter((l) => l.isPermanent);
	}

	private async addCampaign() {
		const campaign = new MarketingCampainDto();
		campaign.targetLink = "https://blexon.com";
		campaign.description = "Beschreibung der Kampagne";
		const response = await httpClient().post(`Marketing/SaveMarketingCampaign`, campaign);
		campaign.id = response.data;
		this.links.unshift(campaign);
	}

	private async saveCampaign(campaign: MarketingCampainDto) {
		try {
			await httpClient().post(`Marketing/SaveMarketingCampaign`, campaign);
			this.$store.commit("setSnackbarText", "Änderungen erfolgreich gespeichert.");
		} catch {
			this.$store.commit(
				"setSnackbarErrorText",
				"Link ist ungültig. Änderungen wurden nicht gespeichert."
			);
		}
	}

	private copyToClipboard(text: string) {
		navigator.clipboard.writeText(text);
	}

	private getPlattformLinks(marketingLink: MarketingCampainDto, plattform: number) {
		try {
			return `https://ads.blexon.com/link/${marketingLink.id}/${plattform}/`;
		} catch {
			return "";
		}
	}

	private getNicePlattformLinks(marketingLink: MarketingCampainDto, plattform: number) {
		return `https://blexon.com/to?id=${marketingLink.id}&p=${plattform}`;
	}

	private getClicks(marketingLink: MarketingCampainDto, plattform: number) {
		const plattformResults = marketingLink.results.filter((r) => r.clickSource === plattform);
		if (plattformResults.length > 0) {
			return plattformResults[0].numberOfClicks;
		}
		return 0;
	}

	private getRegistrations(marketingLink: MarketingCampainDto, plattform: number) {
		const plattformResults = marketingLink.results.filter((r) => r.clickSource === plattform);
		if (plattformResults.length > 0) {
			return plattformResults[0].numberOfRegistrations;
		}
		return 0;
	}

	private getTotalClicks(marketingLink: MarketingCampainDto) {
		let total = 0;
		for (const result of marketingLink.results) {
			total += result.numberOfClicks;
		}
		return total;
	}

	private getTotalRegistrations(marketingLink: MarketingCampainDto) {
		let total = 0;
		for (const result of marketingLink.results) {
			total += result.numberOfRegistrations;
		}
		return total;
	}

	private goToStatistics() {
		this.$router.push({ name: "marketingStatistics" });
	}
}
